<template>
  <div class="ContributionDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="720px"
      custom-class="contribution_editor_dialog"
      :before-close="handleClose"
    >
      <div class="ce_title">我要投稿</div>
      <div class="ce_theme">
        投稿主题：<span>{{ theme ? theme.title : "" }}</span>
      </div>
      <div class="ce_section_label">文章标题</div>
      <el-input
        v-model="form.title"
        class="ce_title_input"
        placeholder="请输入文章标题..."
        maxlength="50"
      ></el-input>
      <div class="ce_section_label">稿件正文</div>
      <div ref="editorRef" class="ce_editor"></div>
      <div class="ce_footer">
        <el-button class="ce_submit" :loading="loading" @click="handleSubmit">提交投稿</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wangEditor from "wangeditor";
import { saveContributionArticleApi } from "@/api/index";

export default {
  name: "ContributionDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      editor: null,
      form: {
        title: "",
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
  },
  watch: {
    //弹窗打开时才初始化正文编辑器（隐藏容器里初始化会拿不到宽度），并清空上一轮内容
    visible(val) {
      if (val) {
        this.form.title = "";
        this.$nextTick(() => {
          this.initEditor();
          this.editor.txt.clear();
        });
      }
    },
    loginPromptSeq() {
      if (this.visible) this.handleClose();
    },
  },
  beforeDestroy() {
    if (this.editor) this.editor.destroy();
    this.editor = null;
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    initEditor() {
      if (this.editor) return;
      this.editor = new wangEditor(this.$refs.editorRef);
      this.editor.config.height = 260;
      this.editor.config.placeholder = "请输入稿件正文...";
      this.editor.config.zIndex = 100;
      //模拟图片上传：本地转 base64 直接插入；接后端后换成调接口再 insertImg(url)
      this.editor.config.customUploadImg = (files, insertImg) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => insertImg(reader.result);
      };
      this.editor.create();
    },
    handleSubmit() {
      const titleText = this.form.title.trim();
      const bodyText = this.editor.txt.text().trim();
      if (!titleText) {
        this.$message.warning("请输入文章标题");
        return;
      }
      if (!bodyText) {
        this.$message.warning("请输入稿件正文");
        return;
      }
      this.loading = true;
      saveContributionArticleApi({
        themeId: this.theme ? this.theme.id : null,
        title: titleText,
        content: this.editor.txt.html(),
      }).then((res) => {
        this.loading = false;
        if (res.code !== 0) {
          this.$message.error(res.msg || "投稿失败");
          return;
        }
        this.$message.success(res.msg || "投稿成功，等待审核");
        this.$emit("success", {
          themeId: this.theme ? this.theme.id : null,
          title: titleText,
          content: this.editor.txt.html(),
        });
        this.handleClose();
      }).catch((err) => {
        this.loading = false;
        this.$message.error((err && err.msg) || "投稿失败");
      });
    },
  },
};
</script>

<style scoped>
.ContributionDialog >>> .contribution_editor_dialog {
  border-radius: 8px;
}

.ContributionDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ContributionDialog >>> .contribution_editor_dialog {
  margin: 0 !important;
}

.ContributionDialog >>> .contribution_editor_dialog .el-dialog__header {
  padding: 0;
}

.ContributionDialog >>> .contribution_editor_dialog .el-dialog__body {
  padding: 28px 32px 24px;
}

.ce_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.ce_theme {
  font-size: 14px;
  color: #999999;
  padding-bottom: 12px;
}

.ce_theme span {
  color: #1b63a7;
  font-weight: 600;
}

.ce_section_label {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  padding-bottom: 8px;
}

.ce_title_input {
  margin-bottom: 16px;
}

.ce_editor {
  margin-bottom: 4px;
}

.ce_footer {
  text-align: center;
  padding-top: 16px;
}

.ce_submit {
  width: 160px;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
}

.ce_submit:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}
</style>


// WEBPACK FOOTER //
// src/views/components/ContributionDialog.vue